/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * PAC API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  BannerDto
} from './pacApi.schemas';

import { axios } from '../../common/axios';
import type { ErrorType , BodyType } from '../../common/axios';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const bannerControllerGetBanner = (

 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<BannerDto>(
      {url: `/api/v1/banner`, method: 'GET', signal
    },
      options);
    }




export const getBannerControllerGetBannerQueryKey = () => {
    return [
    `/api/v1/banner`
    ] as const;
    }


export const getBannerControllerGetBannerQueryOptions = <TData = Awaited<ReturnType<typeof bannerControllerGetBanner>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof bannerControllerGetBanner>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBannerControllerGetBannerQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof bannerControllerGetBanner>>> = ({ signal }) => bannerControllerGetBanner(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof bannerControllerGetBanner>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BannerControllerGetBannerQueryResult = NonNullable<Awaited<ReturnType<typeof bannerControllerGetBanner>>>
export type BannerControllerGetBannerQueryError = ErrorType<unknown>


export function useBannerControllerGetBanner<TData = Awaited<ReturnType<typeof bannerControllerGetBanner>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof bannerControllerGetBanner>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof bannerControllerGetBanner>>,
          TError,
          Awaited<ReturnType<typeof bannerControllerGetBanner>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBannerControllerGetBanner<TData = Awaited<ReturnType<typeof bannerControllerGetBanner>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof bannerControllerGetBanner>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof bannerControllerGetBanner>>,
          TError,
          Awaited<ReturnType<typeof bannerControllerGetBanner>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBannerControllerGetBanner<TData = Awaited<ReturnType<typeof bannerControllerGetBanner>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof bannerControllerGetBanner>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useBannerControllerGetBanner<TData = Awaited<ReturnType<typeof bannerControllerGetBanner>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof bannerControllerGetBanner>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBannerControllerGetBannerQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getBannerControllerGetBannerSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof bannerControllerGetBanner>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof bannerControllerGetBanner>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBannerControllerGetBannerQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof bannerControllerGetBanner>>> = ({ signal }) => bannerControllerGetBanner(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof bannerControllerGetBanner>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BannerControllerGetBannerSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof bannerControllerGetBanner>>>
export type BannerControllerGetBannerSuspenseQueryError = ErrorType<unknown>


export function useBannerControllerGetBannerSuspense<TData = Awaited<ReturnType<typeof bannerControllerGetBanner>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof bannerControllerGetBanner>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBannerControllerGetBannerSuspense<TData = Awaited<ReturnType<typeof bannerControllerGetBanner>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof bannerControllerGetBanner>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBannerControllerGetBannerSuspense<TData = Awaited<ReturnType<typeof bannerControllerGetBanner>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof bannerControllerGetBanner>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useBannerControllerGetBannerSuspense<TData = Awaited<ReturnType<typeof bannerControllerGetBanner>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof bannerControllerGetBanner>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBannerControllerGetBannerSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const bannerControllerUpdateBanner = (
    bannerDto: BodyType<BannerDto>,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<void>(
      {url: `/api/v1/banner`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bannerDto, signal
    },
      options);
    }



export const getBannerControllerUpdateBannerMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bannerControllerUpdateBanner>>, TError,{data: BodyType<BannerDto>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof bannerControllerUpdateBanner>>, TError,{data: BodyType<BannerDto>}, TContext> => {

const mutationKey = ['bannerControllerUpdateBanner'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bannerControllerUpdateBanner>>, {data: BodyType<BannerDto>}> = (props) => {
          const {data} = props ?? {};

          return  bannerControllerUpdateBanner(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BannerControllerUpdateBannerMutationResult = NonNullable<Awaited<ReturnType<typeof bannerControllerUpdateBanner>>>
    export type BannerControllerUpdateBannerMutationBody = BodyType<BannerDto>
    export type BannerControllerUpdateBannerMutationError = ErrorType<unknown>

    export const useBannerControllerUpdateBanner = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bannerControllerUpdateBanner>>, TError,{data: BodyType<BannerDto>}, TContext>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof bannerControllerUpdateBanner>>,
        TError,
        {data: BodyType<BannerDto>},
        TContext
      > => {
      return useMutation(getBannerControllerUpdateBannerMutationOptions(options), queryClient);
    }
